import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const INACTIVITY_TIMEOUT = 60 * 60 * 1000; // 1 hour in milliseconds
const ACTIVITY_KEY = 'lastActivity';

export function useAuth() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/admin/login');
      return;
    }

    // Check if session expired due to inactivity
    const checkInactivity = () => {
      const lastActivity = localStorage.getItem(ACTIVITY_KEY);
      if (lastActivity) {
        const timeSinceActivity = Date.now() - parseInt(lastActivity);
        if (timeSinceActivity > INACTIVITY_TIMEOUT) {
          // Session expired due to inactivity
          localStorage.removeItem('token');
          localStorage.removeItem(ACTIVITY_KEY);
          alert('Your session has expired due to inactivity. Please log in again.');
          navigate('/admin/login');
          return false;
        }
      }
      return true;
    };

    // Initial check
    if (!checkInactivity()) return;

    // Update activity timestamp
    const updateActivity = () => {
      localStorage.setItem(ACTIVITY_KEY, Date.now().toString());
    };

    // Track user activity
    const events = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click'];
    events.forEach(event => {
      window.addEventListener(event, updateActivity);
    });

    // Set initial activity
    updateActivity();

    // Check for inactivity every minute
    const interval = setInterval(() => {
      if (!checkInactivity()) {
        clearInterval(interval);
      }
    }, 60 * 1000); // Check every minute

    // Cleanup
    return () => {
      events.forEach(event => {
        window.removeEventListener(event, updateActivity);
      });
      clearInterval(interval);
    };
  }, [navigate]);

  return {
    isAuthenticated: () => {
      const token = localStorage.getItem('token');
      const lastActivity = localStorage.getItem(ACTIVITY_KEY);
      if (!token || !lastActivity) return false;

      const timeSinceActivity = Date.now() - parseInt(lastActivity);
      return timeSinceActivity <= INACTIVITY_TIMEOUT;
    },
    logout: () => {
      localStorage.removeItem('token');
      localStorage.removeItem(ACTIVITY_KEY);
      navigate('/admin/login');
    }
  };
}
